import { useRouter } from 'next/router'

export const useGetCoursePageUrl = () => {
  const router = useRouter()

  return typeof router.query.coursePath === 'string' ? router.query.coursePath : undefined
}
